import { FileXIcon } from '@phosphor-icons/react'

import { EmptyVisual } from './EmptyVisual'

interface RecordUnavailableProps {
  /** Singular record name as a title: "Invoice", "Deal", "Vendor". */
  record: string
  /** "Back to invoices". */
  backLabel: string
  onBack: () => void
}

/**
 * The page a record detail route shows when its record can't be loaded:
 * deleted, mistyped in the URL, or not shared with the viewer. The API can't
 * tell those apart, so the copy covers all three, and the raw API wording
 * ("Invalid UUID format") never reaches the page.
 */
export function RecordUnavailable({
  record,
  backLabel,
  onBack,
}: RecordUnavailableProps) {
  return (
    <EmptyVisual
      icon={FileXIcon}
      size="page"
      className="min-h-72"
      line={`${record} unavailable`}
      hint="It may have been deleted, or you may not have access."
      action={{ label: backLabel, onClick: onBack }}
    />
  )
}
